<template>
    <div
        v-if="form"
        class="finance-salary"
        v-loading="loading">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="right"
            label-width="80px"
            label-suffix=":">
            <el-form-item :label="$t('Finance.templatename')" prop="name">
                <el-input
                    v-model="form.name"
                    :placeholder="$t('Finance.fill_money')" />
            </el-form-item>
            <el-form-item :label="$t('Finance.templatetype')">
                <el-select
                    v-model="form.type"
                    :placeholder="$t('Common.please_choose')">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item v-if="[3, 4].includes(form.type)">
                <el-radio-group v-model="form.countingWay">
                    <el-radio :label="1">{{ $t('Finance.Settlement_of_Hours') }}</el-radio>
                    <el-radio :label="2">{{ $t('Finance.percentage') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                class="mini-input"
                :label="$t('Finance.Monthly_salary')"
                prop="baseSalary"
                v-if="form.type === 1">
                <el-input type="number" v-model.number="form.baseSalary" />
                <span>{{ $t('Reception.Fifth.yuan') }}</span>
            </el-form-item>
            <el-form-item
                class="mini-input"
                :label="$t('Finance.Monthly_sales')"
                v-else-if="[2, 3].includes(form.type)">
                <div
                    class="mb-4"
                    v-for="(item, index) in form.grades"
                    :key="index">
                    <el-input v-model.number="item.salesFrom" />
                    <span>{{ $t('Finance.including') }}</span>
                    <el-input v-model.number="item.salesTo" />
                    <span>{{ $t('Finance.excluding') }}</span>
                    <el-input v-model.number="item.salary" />
                    <span>%</span>
                    <el-button
                        v-if="index !== 0"
                        type="text"
                        @click="form.grades.splice(index, 1)">
                        {{ $t('tooltip.delete') }}
                    </el-button>
                </div>
                <div
                    v-if="tip"
                    class="tip">
                    {{ tip }}
                </div>
            </el-form-item>
            <el-form-item
                class="mini-input"
                :label="$t('Finance.Monthly_attendance')"
                v-else>
                <div
                    class="mb-4"
                    v-for="(item, index) in form.grades"
                    :key="index">
                    <el-input v-model.number="item.lessonFrom" />
                    <span>{{ $t('Finance.Section_(including)_to') }}</span>
                    <el-input v-model.number="item.lessonTo" />
                    <span>{{ $t('Finance.SectionNo') }}/节</span>
                    <el-input v-model.number="item.salary" />
                    <span>{{ $t('Reception.Fifth.yuan') }}</span>
                    <el-button
                        v-if="index !== 0"
                        type="text"
                        @click="form.grades.splice(index, 1)">
                        {{ $t('tooltip.delete') }}
                    </el-button>
                </div>
                <div
                    v-if="tip"
                    class="tip">
                    {{ tip }}
                </div>
            </el-form-item>
            <el-form-item v-if="form.type !== 1">
                <el-button
                    icon="el-icon-plus"
                    type="primary"
                    @click="handleAdd">
                    {{ $t('Finance.Adding_gradient') }}
                </el-button>
            </el-form-item>
        </el-form>
        <div class="icons text-right">
            <i
                class="el-icon-edit cursor-pointer"
                @click="handleSave" />
            <i
                class="el-icon-delete cursor-pointer"
                @click="$emit('delete')" />
        </div>
    </div>
</template>

<script>
import { RadioGroup, Radio } from 'element-ui';

export default {
    name: 'SalaryItem',
    components: {
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
    },
    props: {
        form: {
            type: Object,
            default: () => ({
                id: '',
                name: '',
                type: 1,
                baseSalary: 0,
                countingWay: 0,
                grades: []
            }),
        },
    },
    data() {
        return {
            loading: false,
            rules: {
                name: [
                    { required: true, type: 'string', message: this.$t('Finance.enter_template_name'), trigger: 'blur' }
                ],
                baseSalary: [
                    { required: true, message: this.$t('Finance.enterMonthlysalary'), trigger: 'blur' },
                    { type: 'number', message: this.$t('Finance.mustnumber'), trigger: 'blur' }
                ],
            },
            options: [
                {
                    label: this.$t('Finance.Monthly_fixed'),
                    value: 1,
                },
                {
                    label: this.$t('Finance.Monthly_sales'),
                    value: 2,
                },
                {
                    label: this.$t('Finance.SettingHours'),
                    value: 3,
                },
                {
                    label: this.$t('Finance.SettingClasses'),
                    value: 4,
                },
            ],
            tip: '',
        };
    },
    watch: {
        'form.type'(val) {
            if ([3, 4].includes(val)) {
                this.form.countingWay = 1;
            } else this.form.countingWay = 0;
            if (this.type === 1) {
                this.rules.baseSalary = [
                    { required: true, message: this.$t('Finance.enterMonthlysalary'), trigger: 'blur' },
                    { type: 'number', message: this.$t('Finance.mustnumber'), trigger: 'blur' }
                ];
            } else {
                delete this.rules.baseSalary;
            }
            this.form.grades = [this.getGrade()];
            this.tip = '';
        }
    },
    computed: {
    },
    methods: {
        handleAdd() {
            this.form.grades.push(this.getGrade());
        },
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) this.postData();
            });
        },
        handleSave() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.type !== 1) {
                    for (const i of this.form.grades) {
                        for (const key of Object.keys(i)) {
                            if (!i[key]) return this.tip = '请填写完整信息~~';
                        }
                        i.countingWay = this.form.countingWay;
                    }
                }
                this.postData();
            });
        },
        async postData() {
            this.loading = true;
            try {
                let res = null;
                if (this.form.id) res = await API.put(`finance/salary-template/${this.form.id}`, this.form);
                else res = await API.post('finance/salary-template', this.form);
                this.loading = false;
                if (res) this.form.id = res.id;
                $ele.$message.success(this.$t('Message.success'));
            } catch (err) {
                this.loading = false;
            }
        },
        getGrade() {
            switch(this.form.type) {
                case 1:
                    return null;
                case 2:
                case 3:
                    return {
                        salesFrom: '',
                        salesTo: '',
                        salary: '',
                    };
                case 4:
                    return {
                        lessonFrom: '',
                        lessonTo: '',
                        salary: '',
                    }
            }
        }
    },
};
</script>

<style lang="scss">
.finance-salary {
    padding: 15px 15px 0 15px;
    border: 1px solid #e6e6e6;
    background-color: #fcfcfc;
    margin-bottom: 15px;
    .el-form-item {
        margin-bottom: 15px;
    }
    .el-input {
        width: 260px;
    }
    .el-form-item__label, .el-form-item__content, .el-radio__label {
        font-size: 12px;
    }
    .mini-input {
        .el-input {
            width: 108px;
        }
        span {
            margin: 0 10px;
        }
    }
    .icons {
        font-size: 18px;
        margin-bottom: 5px;
        i {
            margin-left: 15px;
        }
    }
    .tip {
        color: #f56c6c;
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
        content: '',
    }
}
</style>
